import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { KioskService } from 'src/app/core/services/kiosk.service';
import { LocalDataStoreService } from 'src/app/core/services/local-data-store.service';

@Component({
	selector: 'app-kiosk-init',
	templateUrl: './kiosk-init.component.html',
	styleUrls: ['../kiosk.styles.scss'],
})
export class KioskInitComponent implements OnInit, OnDestroy {
	licensed: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	licenseSubscription: Subscription;
	constructor(public kioskService: KioskService, private route: ActivatedRoute, private localStorage: LocalDataStoreService) {}

	ngOnDestroy(): void {
		this.licenseSubscription.unsubscribe();
	}

	ngOnInit(): void {
		this.licenseSubscription = this.licensed.subscribe((change) => {
			this.initKiosk;
		});
		this.kioskService.venueService.venueKey = +this.route.snapshot.paramMap.get('venueKey');
		this.initKiosk();
	}

	async initKiosk() {
		let licenseKey = await this.localStorage.get('kioskLicenseKey');
		!licenseKey && (licenseKey = 'abcd12345');
		this.licensed.next(true);
		this.kioskService.initKioskVenue(licenseKey);
		return;
		if (!licenseKey) {
			this.licensed.next(false);
		} else {
			this.licensed.next(true);
			this.kioskService.initKioskVenue(licenseKey);
		}
	}
}
